// extracted by mini-css-extract-plugin
export default {"mapTooltip":"style_mapTooltip__gN+2k","detail":"style_detail__iuyrd","tooltipContainer":"style_tooltipContainer__phXvh","mapIcon":"style_mapIcon__owamj","label":"style_label__IzocX"};